import React from "react";
import {
  CreditCard,
  Users,
  Sprout,
  Home,
  Briefcase,
  CheckCircle,
  RefreshCw,
} from "lucide-react";
import { useLanguage } from '../context/LanguageContext';

export default function Auto() {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Auto Provision",
      overview: "Overview",
      overviewText1: "Auto Provisions is a technology-enabled credit facility that provides instant and hassle-free loans to eligible cooperative members. The system automatically assesses eligibility, determines credit limits, and enables quick disbursal for recurring and short-term financial needs—especially for farmers and rural households.",
      overviewText2: "This mechanism significantly reduces manual processing, ensures transparency, and supports members during key crop cycles and livelihood activities.",
      
      whoCanAvail: "Who Can Avail",
      availableFor: [
        {
          title: "Know About Citizens Rights",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "Education & Public Library",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "Government Economy",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "Govt. International Current Affairs",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        }
      ],
      
      types: "Types",
      loanTypes: [
        {
          title: "Crop Cycle Auto Loans",
          items: [
            "Immediate credit during sowing and input stages",
            "Repeatable for each cultivation season"
          ]
        },
        {
          title: "Short-Term Household Support Loans",
          desc: "For essential needs and micro activities"
        },
        {
          title: "Micro-Enterprise Auto Loans",
          desc: "For small traders, women entrepreneurs, and SHG-linked income activities"
        }
      ],
      
      howItWorks: "How It Works",
      steps: [
        {
          title: "Member Profile Sync",
          desc: "Membership details, land records, repayment history, and KCC status updated in MIS."
        },
        {
          title: "Automated Credit Assessment",
          desc: "System calculates eligible credit limit."
        },
        {
          title: "Instant Approval",
          desc: "Eligible members receive automatic sanction without additional paperwork."
        },
        {
          title: "Disbursal",
          desc: "Amount credited directly to the beneficiary's account."
        },
        {
          title: "Tracking and Renewal",
          desc: "Members can view loan status and auto-renew cycles where applicable."
        }
      ]
    },
    ta: {
      title: "ஆட்டோ வழங்கல்",
      overview: "கண்ணோட்டம்",
      overviewText1: "ஆட்டோ வழங்கல் என்பது தொழில்நுட்பம் இயக்கப்பட்ட கடன் வசதியாகும், இது தகுதியான கூட்டுறவு உறுப்பினர்களுக்கு உடனடி மற்றும் சிரமமற்ற கடன்களை வழங்குகிறது. இந்த அமைப்பு தானாகவே தகுதியை மதிப்பீடு செய்கிறது, கடன் வரம்புகளை தீர்மானிக்கிறது, மற்றும் மீண்டும் வரும் மற்றும் குறுகிய கால நிதி தேவைகளுக்கு-குறிப்பாக விவசாயிகள் மற்றும் கிராமப்புற குடும்பங்களுக்கு-விரைவான வழங்கலை செயல்படுத்துகிறது.",
      overviewText2: "இந்த வழிமுறை கைமுறை செயலாக்கத்தை கணிசமாக குறைக்கிறது, வெளிப்படைத்தன்மையை உறுதி செய்கிறது, மற்றும் முக்கிய பயிர் சுழற்சிகள் மற்றும் வாழ்வாதார செயல்பாடுகளின் போது உறுப்பினர்களுக்கு ஆதரவளிக்கிறது.",
      
      whoCanAvail: "யார் பயன்படுத்தலாம்",
      availableFor: [
        {
          title: "குடிமக்கள் உரிமைகளை அறிந்து கொள்ளுங்கள்",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "கல்வி மற்றும் பொது நூலகம்",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "அரசாங்க பொருளாதாரம்",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          title: "அரசு சர்வதேச நடப்பு விவகாரங்கள்",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        }
      ],
      
      types: "வகைகள்",
      loanTypes: [
        {
          title: "பயிர் சுழற்சி ஆட்டோ கடன்கள்",
          items: [
            "விதைப்பு மற்றும் உள்ளீட்டு நிலைகளில் உடனடி கடன்",
            "ஒவ்வொரு சாகுபடி பருவத்திற்கும் மீண்டும் செய்யக்கூடியது"
          ]
        },
        {
          title: "குறுகிய கால குடும்ப ஆதரவு கடன்கள்",
          desc: "அத்தியாவசிய தேவைகள் மற்றும் நுண்ணிய செயல்பாடுகளுக்கு"
        },
        {
          title: "நுண்ணிய-நிறுவன ஆட்டோ கடன்கள்",
          desc: "சிறு வர்த்தகர்கள், பெண் தொழில்முனைவோர் மற்றும் SHG-இணைக்கப்பட்ட வருமான செயல்பாடுகளுக்கு"
        }
      ],
      
      howItWorks: "இது எவ்வாறு செயல்படுகிறது",
      steps: [
        {
          title: "உறுப்பினர் சுயவிவர ஒத்திசைவு",
          desc: "உறுப்பினர் விவரங்கள், நில பதிவுகள், திருப்பிச் செலுத்தும் வரலாறு மற்றும் KCC நிலை MIS இல் புதுப்பிக்கப்பட்டது."
        },
        {
          title: "தானியங்கு கடன் மதிப்பீடு",
          desc: "அமைப்பு தகுதியான கடன் வரம்பைக் கணக்கிடுகிறது."
        },
        {
          title: "உடனடி ஒப்புதல்",
          desc: "தகுதியான உறுப்பினர்கள் கூடுதல் காகித வேலைகள் இல்லாமல் தானியங்கு அனுமதியைப் பெறுகிறார்கள்."
        },
        {
          title: "வழங்கல்",
          desc: "பயனாளியின் கணக்கில் நேரடியாக தொகை வரவு வைக்கப்படுகிறது."
        },
        {
          title: "கண்காணிப்பு மற்றும் புதுப்பித்தல்",
          desc: "உறுப்பினர்கள் கடன் நிலையைப் பார்க்கலாம் மற்றும் பொருந்தும் இடங்களில் தானாக புதுப்பித்தல் சுழற்சிகளைப் பெறலாம்."
        }
      ]
    }
  };

  const t = content[language];

  return (
    <div className="bg-white w-full">
      {/* Top Header Bar */}
      <div className="w-full bg-white py-8">
        <h1 className="text-center text-4xl font-bold text-gray-900">
          {t.title}
        </h1>
      </div>

      <div className="px-6 lg:px-20 py-12 -mt-10">
        {/* Overview Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            {t.overview}
          </h2>

          <div className="bg-[#f1f7ff] rounded-2xl p-6 lg:p-8 relative">
            <div className="absolute left-0 top-6 bottom-6 w-1 bg-[#0b5ed7] rounded-full" />
            <p className="pl-6 text-gray-700 text-lg leading-relaxed">
              {t.overviewText1}
              <br /><br />
              {t.overviewText2}
            </p>
          </div>
        </div>

        {/* Full width grey section - Who Can Avail */}
        <div className="bg-gray-100 py-10 -mt-5">
          <h2 className="text-3xl font-semibold text-gray-900 mb-10 text-center">
            {t.whoCanAvail}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 lg:px-16">
            {t.availableFor.map((card, index) => {
              const bgColors = [
                "bg-[#1e40af]",
                "bg-[#4338ca]",
                "bg-[#0f766e]",
                "bg-[#475569]"
              ];

              return (
                <div
                  key={index}
                  className={`${bgColors[index]} text-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-transform hover:-translate-y-1`}
                >
                  <div className="flex justify-center mb-4">
                    <div className="bg-white/20 rounded-full p-4">
                      {/* icon here */}
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold text-center mb-2">
                    {card.title}
                  </h3>

                  <p className="text-sm text-white/90 text-center leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Types */}
        <div className="mb-10 sm:mb-16 pt-2">
          <h2 className="text-3xl font-semibold text-gray-900 mb-10 text-center">
            {t.types}
          </h2>

          <div className="flex flex-col md:flex-row items-stretch w-full">

            {/* Type 1 – Dark Blue */}
            <div className="relative flex-1 bg-[#264d6c] text-white px-8 py-6 shadow-md rounded-l-2xl">
              <div className="flex items-start gap-4">
                <div className="bg-white/20 p-2 rounded-full">
                  <Sprout />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    {t.loanTypes[0].title}
                  </h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    {t.loanTypes[0].items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="hidden md:block absolute top-0 right-0 h-full w-10 bg-[#264d6c] chevron-right" />
            </div>

            {/* Type 2 – Mint Green */}
            <div className="relative flex-1 bg-[#cfece4] text-[#264d6c] px-8 py-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="bg-[#264d6c]/20 p-2 rounded-full">
                  <Home />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    {t.loanTypes[1].title}
                  </h3>
                  <p className="text-sm">
                    {t.loanTypes[1].desc}
                  </p>
                </div>
              </div>

              <div className="hidden md:block absolute top-0 right-0 h-full w-10 bg-[#cfece4] chevron-right" />
            </div>

            {/* Type 3 – Light Blue */}
            <div className="flex-1 bg-[#86aadf] text-white px-8 py-6 shadow-md rounded-r-2xl">
              <div className="flex items-start gap-4">
                <div className="bg-white/20 p-2 rounded-full">
                  <Briefcase />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">
                    {t.loanTypes[2].title}
                  </h3>
                  <p className="text-sm">
                    {t.loanTypes[2].desc}
                  </p>
                </div>
              </div>
            </div>

          </div>

          <style jsx>{`
            .chevron-right {
              clip-path: polygon(0 0, 85% 50%, 0 100%, 15% 100%, 100% 50%, 15% 0);
            }
          `}</style>
        </div>

        {/* How It Works */}
        <div className="w-full bg-gray-100 py-10 sm:py-16">
          <h2 className="text-3xl font-semibold text-gray-900 mb-12 text-center">
            {t.howItWorks}
          </h2>

          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {t.steps.map((step, index) => {
                const icons = [
                  <RefreshCw key="icon1" />,
                  <CreditCard key="icon2" />,
                  <CheckCircle key="icon3" />,
                  <CreditCard key="icon4" />,
                  <RefreshCw key="icon5" />
                ];

                return (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 shadow-md border-t-4 border-[#0b5ed7]"
                  >
                    <div className="flex items-center gap-3 mb-3 text-[#0b5ed7]">
                      {icons[index]}
                      <h4 className="text-lg font-semibold">
                        {step.title}
                      </h4>
                    </div>
                    <p className="text-gray-700 text-sm">
                      {step.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}